<script setup lang="ts">
/**
 * Paper grain (#241) — a faint, fixed fractal-noise veil over the whole page. The
 * styleguide treats materiality as load-bearing ("the warmth IS the texture —
 * budget for it, don't drop it"); this is the texture, applied app-wide.
 *
 * It's an inline SVG `feTurbulence` (not a CSS data-URI) so it stays editable and
 * adds no extra request — this is an offline-first app. The veil sits over content
 * at a deliberately tiny effective alpha (~0.025 = rect opacity 0.05 × element
 * opacity 0.5), enough to warm flat surfaces without touching legibility, and is
 * `pointer-events: none` so it never intercepts input. `color` is fixed across
 * themes — grey noise reads the same on parchment or near-black.
 *
 * Meant to be mounted once, at the app shell (the filter id is a singleton).
 */
</script>

<template>
  <svg class="paper-grain" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
    <filter id="paper-grain-noise">
      <feTurbulence type="fractalNoise" baseFrequency="0.9" numOctaves="2" stitchTiles="stitch" />
      <feColorMatrix type="saturate" values="0" />
    </filter>
    <rect width="100%" height="100%" filter="url(#paper-grain-noise)" opacity="0.05" />
  </svg>
</template>

<style scoped>
.paper-grain {
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
  opacity: 0.5;
}
</style>
